module.exports = __webpack_public_path__ + "img/power.3d374bfc.svg";